import React from 'react';
import CustomFieldsModal from './CustomFieldsModal';
import useCustomFields, { addressIsBlank, groupByTicket } from '../hooks/useCustomFields';
import { renderCustomFieldDisplayValue } from '../../shared/utils/customFieldHelpers';

const isBlank = (cfv) => (
  cfv.type === 'CustomFieldValues::Address'
    ? addressIsBlank(cfv.value)
    : cfv.value == null || cfv.value === ''
);

const OrderCustomFieldsCard = ({ customFieldValues, passAnswers = [], canEdit, team, confirm, csrfToken, updateUrl, defaultCountry }) => {
  const { values, open, openModal, closeModal, editValues, change, canSave, submitting, submit } = useCustomFields({
    csrfToken,
    updateUrl,
    customFieldValues,
  });

  const orderValues = values.filter((cfv) => !cfv.ticketId);
  const ticketGroups = groupByTicket(values);
  const hasOrderFields = values.length > 0;
  if (!hasOrderFields && passAnswers.length === 0) return null;

  const valueCell = (cfv) => (
    isBlank(cfv) ? <span className="op-muted">—</span> : renderCustomFieldDisplayValue(cfv, team.id)
  );

  return (
    <div className="op-card">
      <div className="op-card-head">
        <h2 className="op-section-title">Custom Fields</h2>
        {canEdit && hasOrderFields ? (
          <button type="button" className="op-btn" onClick={openModal}>
            <i className="fal fa-pen mr-1"></i>Edit
          </button>
        ) : null}
      </div>
      <table className="op-table op-cf-table">
        <thead>
          <tr><th>Field</th><th>Value</th></tr>
        </thead>
        <tbody>
          {orderValues.map((cfv) => (
            <tr key={cfv.custom_field.id}>
              <td data-label="Field">{cfv.custom_field.name}</td>
              <td data-label="Value">{valueCell(cfv)}</td>
            </tr>
          ))}
        </tbody>
        {ticketGroups.map((group) => (
          <tbody key={group.ticketId} data-testid={`ticket-answers-${group.ticketId}`}>
            <tr className="op-cf-group-row">
              <td colSpan={2} className="op-cf-group">{group.label}</td>
            </tr>
            {group.values.map((cfv) => (
              <tr key={cfv.custom_field.id}>
                <td data-label="Field">{cfv.custom_field.name}</td>
                <td data-label="Value">{valueCell(cfv)}</td>
              </tr>
            ))}
          </tbody>
        ))}
        {passAnswers.map((pass) => (
          <tbody key={pass.ticketId} data-testid={`pass-answers-${pass.ticketId}`}>
            <tr className="op-cf-group-row">
              <td colSpan={2} className="op-cf-group">Pass {pass.passNumber}</td>
            </tr>
            {pass.answers.map((answer) => (
              <tr key={answer.id}>
                <td data-label="Field">{answer.name}</td>
                <td data-label="Value">
                  {isBlank(answer) ? <span className="op-muted">—</span> : renderCustomFieldDisplayValue(answer, team.id)}
                </td>
              </tr>
            ))}
          </tbody>
        ))}
      </table>
      <CustomFieldsModal
        open={open}
        onClose={closeModal}
        values={editValues}
        onChange={change}
        onSubmit={submit}
        canSave={canSave}
        submitting={submitting}
        team={team}
        confirm={confirm}
        csrfToken={csrfToken}
        defaultCountry={defaultCountry}
      />
    </div>
  );
};

export default OrderCustomFieldsCard;
